import script from "./selectAvatarDialogNew.vue?vue&type=script&lang=ts&setup=true"
export * from "./selectAvatarDialogNew.vue?vue&type=script&lang=ts&setup=true"

import "./selectAvatarDialogNew.vue?vue&type=style&index=0&id=5d460962&lang=less&scoped=true"

import exportComponent from "/opt/teams-app/node_modules/.pnpm/vue-loader@17.0.0_webpack@5.74.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d460962"]])

export default __exports__